import React, { FC, ReactNode } from "react";

import { Container } from "../../container";

export interface JobDetailLayoutProps {
  title: ReactNode;
  description: ReactNode;
  jobDescription: ReactNode;
  ctas: ReactNode;
  labels: Record<string, string | null>;
}

export const JobDetailLayout: FC<JobDetailLayoutProps> = ({
  title,
  description,
  jobDescription,
  ctas,
  labels,
}) => {
  return (
    <Container className="py-16 bg-neutral" containerClassName="flex flex-col gap-14" pagePaddingX>
      <div>
        <h2 className="text-4xl md:text-5xl text-primary mb-6 md:mb-14">{title}</h2>

        <div className="flex flex-col md:flex-row md:justify-between gap-8 lg:gap-16 xl:gap-20 w-full">
          <div className="html-content flex-1">{description}</div>
          {ctas && <div className="flex flex-col sm:flex-row md:flex-col gap-4">{ctas}</div>}
        </div>
      </div>

      <div className="rounded-xl overflow-hidden bg-light p-8 lg:p-14">
        <h3 className="text-3xl text-primary mb-2">{labels["job-description"]}</h3>
        <div className="html-content mt-6">{jobDescription}</div>
      </div>
    </Container>
  );
};
